import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export const CaptchaOverlay = ({ onVerify, captchaKey }) => {
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // Ensure the component is only rendered on the client-side
    setIsClient(true);
  }, []);

  const handleCaptchaChange = (token) => {
    if (token) {
      onVerify(token);
    }
  };

  if (!isClient) {
    return null; // Avoid rendering on the server-side
  }

  return (
    <div style={overlayStyle}>
      <div style={captchaContainerStyle}>
        <ReCAPTCHA sitekey={captchaKey} onChange={handleCaptchaChange} />
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "#fff",
  zIndex: 9999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const captchaContainerStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
};
